import { defineStore } from "pinia";

import { ACTION_FAMILY_INIT, GETTER_FAMILY } from "@etab/stores/types";
import { EtabFamilyService } from "@core/services";
import { EtabFamilyModel } from "@core/models";

export const useEtabFamilyStore = defineStore("etabFamily", {
  // convert to a function
  state: () => ({
    families: [],
  }),
  getters: {
    [GETTER_FAMILY]: (state) => (state.families || []).map((family) => new EtabFamilyModel(family)),
  },
  actions: {
    async [ACTION_FAMILY_INIT]() {
      const data = await EtabFamilyService.getFamiliesList();
      this.families = data;
    },
    // easily reset state using `$reset`
    clearEtabFamilyStore() {
      this.$reset();
    },
  },
});
